import { useCallback, useEffect, useMemo, useState } from "react";
import { useAuth } from "../../../../hooks";
import { DashboardReviApi } from "../../../../api/revi/dashboardApi";

export function useTherapistDashboardController() {
  const { accessToken } = useAuth();

  const api = useMemo(() => new DashboardReviApi(), []);

  const [timeRange, setTimeRange] = useState("last_30_days");

  const [summary, setSummary] = useState(null);
  const [charts, setCharts] = useState({ distribution: [], evolution: [] });
  const [activity, setActivity] = useState([]);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    if (!accessToken) return;

    setLoading(true);
    setError("");

    try {
      const [summaryRes, chartsRes, activityRes] = await Promise.all([
        api.getSummary(accessToken, { timeRange }),
        api.getCharts(accessToken, { timeRange }),
        api.getActivity(accessToken, { timeRange }),
      ]);

      setSummary(summaryRes?.data || null);
      setCharts(chartsRes?.charts || { distribution: [], evolution: [] });
      setActivity(activityRes?.activity || []);
    } catch (e) {
      setError(e?.message || "Error cargando dashboard");
    } finally {
      setLoading(false);
    }
  }, [accessToken, api, timeRange]);

  useEffect(() => {
    load();
  }, [load]);

  return {
    timeRange,
    setTimeRange,
    summary,
    charts,
    activity,
    loading,
    error,
    reload: load,
  };
}
